import axios from 'axios';
import * as appConstants from "../constants/index";
const theme = localStorage.getItem("theme");

let splashData;
let financialData;

export const getSplashData = async ()=>{
    if(splashData) return splashData; 
    else{
        const response = await axios
        .post(
            `${appConstants.base_url}v1/booking/content/splash`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    chain: theme === "inoxTheme" ? "INOX" : "PVR",
                    city: localStorage.getItem("city"),
                    appVersion: appConstants.av,
                    platform: appConstants.pt,
                    country: appConstants.cname,
                },
            }
        );
        splashData = response;
        return response;
    }
} 

export const getFinancialDataApi = async ()=>{
    if(financialData) return financialData; 
    else{
        const response = await axios
        .post(
            `${appConstants.base_url}v1/web/financials`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    chain: theme === "inoxTheme" ? "INOX" : "PVR",
                    city: localStorage.getItem("city"),
                    appVersion: appConstants.av,
                    platform: appConstants.pt,
                    country: appConstants.cname,
                },
            }
        );
        financialData = response;
        return response;
    }
} 

export const getGoogleWalletApi = async (bookingid, booktype)=>{
        const response = await axios
        .post(
            `${appConstants.base_url}v1/wallet/google/${bookingid}/${booktype}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    chain: theme === "inoxTheme" ? "INOX" : "PVR",
                    city: localStorage.getItem("city"),
                    appVersion: appConstants.av,
                    platform: appConstants.pt,
                    country: appConstants.cname,
                },
            }
        );
        return response;    
}

export const datalayer = async (param) =>{
    let dataLayer = window.dataLayer || [];
    dataLayer.push(param);
}
